export default function PreparednessHero() {
  return (
    <div className="relative bg-gradient-to-br from-red-600 via-orange-600 to-amber-600 text-white overflow-hidden">
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <i className="ri-shield-check-line text-xl"></i>
            <span className="font-medium">Emergency Preparedness</span>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Be Ready for Anything
          </h1>
          
          <p className="text-xl md:text-2xl text-white/90 mb-8 leading-relaxed">
            Build your emergency kit and create a family plan to protect what matters most. 
            Roseville residents, prepare today for a safer tomorrow.
          </p>
          
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="#checklist"
              className="inline-flex items-center gap-2 bg-white text-orange-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              <i className="ri-checkbox-line text-xl"></i>
              Start Your Checklist
            </a>
            <a
              href="#family-plan"
              className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-all whitespace-nowrap"
            >
              <i className="ri-team-line text-xl"></i>
              Create Family Plan
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
